import axios from '../plugins/axios';

import User from './repositories/user';
import Post from './repositories/post';
import PostRating from './repositories/postRating';
import PostVideos from './repositories/postVideos';
import SnsPosting from './repositories/snsPosting';
import SnsProduct from './repositories/snsProduct';
import SnsUser from './repositories/snsUser';
import SnsPayments from './repositories/snsPayments';
import Product from './repositories/product';
import Menu from './repositories/menu';
import Cart from './repositories/cart';
import Rent from './repositories/rent';
import Alarm from './repositories/alarm';
import Card from './repositories/card';
import Payment from './repositories/payment';
import Model from './repositories/models';
import Guide from './repositories/guide';
import Guidelines from './repositories/guidelines';
import GuidelineRules from './repositories/guidelineRules';
import Auth from './repositories/brandAuth';
import Category from './repositories/category';
import Style from './repositories/style';
import Size from './repositories/size';
import Brand from './repositories/brand';
import BrandSns from './repositories/brandSns';
import Billing from './repositories/billing';
import Campaign from './repositories/campaign';
import CampaignApplicants from './repositories/campaignApplicants';
import CampaignManager from './repositories/campaignManager/campaignManager';
import CampaignPayments from './repositories/campaignPayments';
import CampaignImages from './repositories/campaignImages';
import Like from './repositories/like';
import Chart from './repositories/chart';
import Settings from './repositories/settings';
import Ambassador from './repositories/brandAmbassador';
import AmbassadorPreferences from './repositories/brandAmbassadorPreferences';
import BusinessContact from './repositories/businessContact';
import InspectionFeedback from './repositories/inspectionFeedback';
import Instagram from './repositories/instagram';

import EmergencyProducts from './repositories/emergency/products';
import EmergencyRentals from './repositories/emergency/rentals';
import Dev from './repositories/dev';
import Commission from './repositories/commission';
import MatchRating from './repositories/matchRating';

import productUserLike from "./repositories/productUserLike"
import Lecture from './repositories/lecture';
import LectureLesson from './repositories/lectureLesson';
import LectureChapter from './repositories/lectureChapter';
import FacebookAds from './repositories/facebookAds';

const API = ($axios: any) => ({
  User: User($axios),
  Post: Post($axios),
  PostRating: PostRating($axios),
  PostVideos: PostVideos($axios),
  SnsPosting: SnsPosting($axios),
  SnsProduct: SnsProduct($axios),
  SnsUser: SnsUser($axios),
  SnsPayments: SnsPayments($axios),
  Product: Product($axios),
  Menu: Menu($axios),
  Cart: Cart($axios),
  Rent: Rent($axios),
  Alarm: Alarm($axios),
  Payment: Payment($axios),
  Model: Model($axios),
  Card: Card($axios),
  Guide: Guide($axios),
  Guidelines: Guidelines($axios),
  GuidelineRules: GuidelineRules($axios),
  Auth: Auth($axios),
  Category: Category($axios),
  Style: Style($axios),
  Size: Size($axios),
  Brand: Brand($axios),
  BrandSns: BrandSns($axios),
  Ambassador: Ambassador($axios),
  AmbassadorPreferences: AmbassadorPreferences($axios),
  Billing: Billing($axios),
  Campaign: Campaign($axios),
  CampaignApplicants: CampaignApplicants($axios),
  CampaignManager: CampaignManager($axios),
  CampaignPayments: CampaignPayments($axios),
  CampaignImages: CampaignImages($axios),
  Like: Like($axios),
  ProductUserLike: productUserLike($axios), 
  Chart: Chart($axios),
  Settings: Settings($axios),
  BusinessContact: BusinessContact($axios),
  InspectionFeedback: InspectionFeedback($axios),
  Instagram: Instagram($axios),
  Commission: Commission($axios),
  MatchRating: MatchRating($axios),
  FacebookAds: FacebookAds($axios),

  EmergencyProducts: EmergencyProducts($axios),
  EmergencyRentals: EmergencyRentals($axios),

  Dev: Dev($axios),

  axios: $axios,
  Lecture: Lecture($axios),
  LectureLesson: LectureLesson($axios),
  LectureChapter: LectureChapter($axios),
});

export default API(axios);
